<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder">
    <ul class="dl-nodemenu">
        @if (!condtag || node.data('condstate') === condtag.state) {
            <li class="dl-nodemenu__item" (click)="uitvoerSwitchArgs()" title="{{ 'SWITCH_ARGS' | translate }}">
                <a class="switch_args"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
</div>
